import * as React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { ITranslationsCollection, translate, ServiceView } from '@estee/elc-service';
import { classes } from '../utils/Classes';
import { RemoveIcon } from '@estee/elc-icons';
import { ResponsiveModal } from '@estee/elc-responsive-modal';
import { AutoReplenishmentInfoModalTrigger } from './AutoReplenishmentInfoModalTrigger';
import styled from 'styled-components';
import { IAutoReplenishOptions } from '../../exported/auto-replenishment/AutoReplenishment';
import { Button } from '@estee/elc-buttons';
import { CONTENT_BLOCK } from '@estee/elc-service-view-names';
import { serviceName, version } from '../../service-setup/packageInfo';

export interface IAutoReplenishInfoModalOptions {
    translations?: ITranslationsCollection;
    config: IAutoReplenishOptions;
}

const AutoReplenishModalWrapper = styled.div`
    width: 100%;
    height: 100%;
`;

@translate(['closeLabel', 'autoReplenishMoreInformation'])
@observer
export class AutoReplenishmentInfoModal extends React.Component<IAutoReplenishInfoModalOptions> {
    @observable private isAutoReplenishInfoModalOpen: boolean = false;

    private toggleAutoReplenishInfoModal = (
        event?: React.MouseEvent<HTMLDivElement | HTMLButtonElement>
    ) => {
        // click triggered from IframeModal so might not have an event
        if (event) {
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();
        }

        this.isAutoReplenishInfoModalOpen = !this.isAutoReplenishInfoModalOpen;
    };

    public render() {
        const { infoPopupTriggerType, infoPopupNodeId } = this.props.config;

        const { closeLabel, autoReplenishMoreInformation } = this.props
            .translations as ITranslationsCollection;

        const autoReplenishModalClass = classes('auto-replenish-modal');
        const autoReplenishModalCloseButtonIconClass = classes(
            'auto-replenish-modal-close-button-icon'
        );

        const productContentConfig = {
            nid: infoPopupNodeId as number
        };

        return (
            <>
                {infoPopupTriggerType && (
                    <AutoReplenishmentInfoModalTrigger
                        onClick={this.toggleAutoReplenishInfoModal}
                        triggerType={infoPopupTriggerType}
                    />
                )}
                <ResponsiveModal
                    isOpen={this.isAutoReplenishInfoModalOpen}
                    onMaskClick={this.toggleAutoReplenishInfoModal}
                    title={autoReplenishMoreInformation}
                >
                    <Button
                        aria-label={`${closeLabel} autoReplenishModalLabel`}
                        value="close-auto-replenish-modal-button"
                        className={autoReplenishModalCloseButtonIconClass}
                        onClick={this.toggleAutoReplenishInfoModal}
                        title={`${closeLabel} ${autoReplenishMoreInformation}`}
                    >
                        <RemoveIcon />
                        {infoPopupNodeId && (
                            <AutoReplenishModalWrapper className={autoReplenishModalClass}>
                                <ServiceView
                                    name={CONTENT_BLOCK}
                                    serviceName={serviceName}
                                    config={productContentConfig}
                                    version={version}
                                />
                            </AutoReplenishModalWrapper>
                        )}
                    </Button>
                </ResponsiveModal>
            </>
        );
    }
}
